import React, { useState } from 'react';
import { Check, X, Sparkles, Shield, Users, User, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function PricingPage() {
  const [isAnnual, setIsAnnual] = useState(true);
  return <div className="flex flex-col min-h-screen w-full font-inter bg-white" data-id="element-1776">
      <TopBar data-id="element-1777" />
      <Header data-id="element-1778" />

      {/* Hero Section */}
      <section className="w-full bg-white py-16 md:py-24 border-b border-gray-200" data-id="element-1779">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-1780">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#111111] mb-6 leading-tight" data-id="element-1781">
            Simple, Honest Pricing for Your
            <br className="hidden md:block" data-id="element-1782" /> Family's Digital Future.
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1783">
            No upsells, no confusing add-ons, and no fear-mongering. Just
            straightforward plans that build your family's digital confidence.
            Choose the plan that's right for you.
          </p>

          {/* Monthly/Annual Toggle */}
          <div className="mt-12 flex items-center justify-center space-x-4" data-id="element-1784">
            <span className={`text-lg font-medium ${!isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-1785">
              Monthly
            </span>
            <button onClick={() => setIsAnnual(!isAnnual)} className="relative w-16 h-8 bg-#[631bb7] rounded-full p-1 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-#[631bb7]" data-id="element-1786">
              <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${isAnnual ? 'translate-x-8' : 'translate-x-0'}`} data-id="element-1787" />
            </button>
            <span className={`text-lg font-medium ${isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-1788">
              Annual <span className="text-[#631bb7] text-sm" data-id="element-1789">(Save 20%)</span>
            </span>
          </div>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-1790">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1791">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-1792">
            {/* Foundation (Free) */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full" data-id="element-1793">
              <div className="mb-6" data-id="element-1794">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-1795">
                  Foundation
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-1796">
                  Essential basics for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-1797">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-1798">
                  $0
                </span>
                <span className="text-gray-500 ml-1" data-id="element-1799">/forever</span>
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-gray-100 text-[#111111] font-bold rounded-lg hover:bg-gray-200 transition-colors mb-8" data-id="element-1800">
                Start for Free
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-1801">
                <li className="flex items-start" data-id="element-1802">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1803" />
                  <span className="text-gray-700 text-sm" data-id="element-1804">1 Member</span>
                </li>
                <li className="flex items-start" data-id="element-1805">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1806" />
                  <span className="text-gray-700 text-sm" data-id="element-1807">
                    Basic Security Assessment
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1808">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1809" />
                  <span className="text-gray-700 text-sm" data-id="element-1810">
                    Intro & Level 1 Modules
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1811">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1812" />
                  <span className="text-gray-700 text-sm" data-id="element-1813">
                    Specialized Guides
                  </span>
                </li>
              </ul>
            </div>

            {/* Individual */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full relative" data-id="element-1814">
              <div className="mb-6" data-id="element-1815">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-1816">
                  Individual
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-1817">
                  Full access for one person
                </p>
              </div>
              <div className="mb-8" data-id="element-1818">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-1819">
                  {isAnnual ? '$79' : '$7.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-1820">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-1821">
                    Save $16/year
                  </p>}
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-[#1a0647] text-white font-bold rounded-lg hover:bg-[#2d0b75] transition-colors mb-8" data-id="element-1822">
                Choose Individual
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-1823">
                <li className="flex items-start" data-id="element-1824">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1825" />
                  <span className="text-gray-700 text-sm" data-id="element-1826">1 Member</span>
                </li>
                <li className="flex items-start" data-id="element-1827">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1828" />
                  <span className="text-gray-700 text-sm" data-id="element-1829">
                    Everything in Foundation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1830">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1831" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-1832">
                    Full Access to All 37 Modules
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1833">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1834" />
                  <span className="text-gray-700 text-sm" data-id="element-1835">
                    Personal Dashboard & Scoring
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1836">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1837" />
                  <span className="text-gray-700 text-sm" data-id="element-1838">
                    Personalized Task Queue
                  </span>
                </li>
              </ul>
            </div>

            {/* Family (Best Value) */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7] shadow-xl flex flex-col h-full relative transform md:-translate-y-4" data-id="element-1839">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-1840">
                Best Value
              </div>
              <div className="mb-6 mt-2" data-id="element-1841">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-1842">Family</h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-1843">
                  Complete protection for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-1844">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-1845">
                  {isAnnual ? '$199' : '$19.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-1846">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-1847">
                    Save $40/year
                  </p>}
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-[#631bb7] text-white font-bold rounded-lg hover:bg-[#521099] transition-colors mb-8 shadow-md" data-id="element-1848">
                Choose Family
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-1849">
                <li className="flex items-start" data-id="element-1850">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1851" />
                  <span className="text-gray-700 text-sm font-bold" data-id="element-1852">
                    Up to 6 Members
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1853">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1854" />
                  <span className="text-gray-700 text-sm" data-id="element-1855">
                    Everything in Individual
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1856">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1857" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-1858">
                    Family Coordination Dashboard
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1859">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1860" />
                  <span className="text-gray-700 text-sm" data-id="element-1861">
                    Role-Based Views
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1862">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1863" />
                  <span className="text-gray-700 text-sm" data-id="element-1864">
                    Shared Task Queue & Delegation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1865">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1866" />
                  <span className="text-gray-700 text-sm" data-id="element-1867">
                    Cross-Family Progress Tracking
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Lifetime Offer Section */}
      <section className="w-full bg-[#1a0647] py-16 md:py-24 relative overflow-hidden" data-id="element-1868">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-1869">
          <div className="absolute top-10 left-10 w-64 h-64 bg-[#8041bf] rounded-full filter blur-3xl" data-id="element-1870"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#00f4f8] rounded-full filter blur-3xl" data-id="element-1871"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-1872">
          <div className="text-center mb-12" data-id="element-1873">
            <div className="inline-block bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1874">
              Limited-Time Founding Member Offer
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-1875">
              Become a Founding Member.
              <br data-id="element-1876" /> Pay Once, Protected Forever.
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-1877">
              For our first 1,000 customers, we're offering exclusive lifetime
              access. Secure your family's digital future and support our
              mission to make the internet a safer place for everyone. This
              offer will not be available again.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1878">
            {/* Lifetime Individual */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-8 border border-white border-opacity-20 hover:bg-opacity-15 transition-all" data-id="element-1879">
              <div className="flex items-center justify-between mb-6" data-id="element-1880">
                <h3 className="text-2xl font-bold text-white" data-id="element-1881">
                  Lifetime Individual
                </h3>
                <User className="text-[#00f4f8] w-8 h-8" data-id="element-1882" />
              </div>
              <div className="mb-6" data-id="element-1883">
                <span className="text-5xl font-extrabold text-white" data-id="element-1884">$199</span>
                <p className="text-[#00f4f8] font-medium mt-2" data-id="element-1885">
                  One-Time Payment
                </p>
              </div>
              <p className="text-gray-300 mb-8" data-id="element-1886">
                Includes all future updates to the Individual Plan.
              </p>
              <button className="w-full py-4 px-6 bg-white text-[#1a0647] font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1887">
                Get Lifetime Individual
              </button>
            </div>

            {/* Lifetime Family */}
            <div className="bg-gradient-to-br from-[#631bb7] to-[#521099] rounded-2xl p-8 border border-white border-opacity-20 shadow-2xl transform md:scale-105" data-id="element-1888">
              <div className="flex items-center justify-between mb-6" data-id="element-1889">
                <h3 className="text-2xl font-bold text-white" data-id="element-1890">
                  Lifetime Family
                </h3>
                <Users className="text-white w-8 h-8" data-id="element-1891" />
              </div>
              <div className="mb-6" data-id="element-1892">
                <span className="text-5xl font-extrabold text-white" data-id="element-1893">$599</span>
                <p className="text-white text-opacity-90 font-medium mt-2" data-id="element-1894">
                  One-Time Payment
                </p>
              </div>
              <p className="text-white text-opacity-80 mb-8" data-id="element-1895">
                Includes all future updates to the Family Plan for up to 6
                members.
              </p>
              <button className="w-full py-4 px-6 bg-[#00f4f8] text-[#1a0647] font-bold rounded-lg hover:bg-[#00e0e4] transition-colors shadow-lg" data-id="element-1896">
                Get Lifetime Family
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Competitive Comparison */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1897">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1898">
          <div className="text-center mb-12" data-id="element-1899">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-1900">
              Why Overpay for Anxiety When You Can Invest in Capability?
            </h2>
          </div>

          <div className="overflow-x-auto" data-id="element-1901">
            <table className="w-full max-w-5xl mx-auto border-collapse" data-id="element-1902">
              <thead data-id="element-1903">
                <tr data-id="element-1904">
                  <th className="text-left py-4 px-6 font-bold text-gray-500 uppercase text-sm tracking-wider border-b-2 border-gray-100" data-id="element-1905"></th>
                  <th className="text-left py-4 px-6 border-b-2 border-[#631bb7]" data-id="element-1906">
                    <div className="text-xl font-bold text-[#631bb7]" data-id="element-1907">
                      Caveo
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-1908">
                    <div className="text-xl font-bold text-gray-600" data-id="element-1909">
                      Norton 360 / Aura
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-1910">
                    <div className="text-xl font-bold text-gray-600" data-id="element-1911">
                      Geek Squad
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-1912">
                {[{
                label: 'Philosophy',
                caveo: 'Builds your capability',
                competitor1: 'Sells reactive alerts & fear',
                competitor2: 'Profits from your tech breaking'
              }, {
                label: 'Cost',
                caveo: 'Starts at $7.99/mo',
                competitor1: '$12 - $35/mo',
                competitor2: '$99+ per incident'
              }, {
                label: 'Experience',
                caveo: 'Plain-English guidance',
                competitor1: 'Confusing technical jargon',
                competitor2: 'In-person visit required'
              }, {
                label: 'Incentive',
                caveo: 'We win when you feel confident',
                competitor1: 'They win when you stay anxious',
                competitor2: 'They win when you have problems'
              }, {
                label: 'Outcome',
                caveo: 'Digital Independence',
                competitor1: 'Dependency & Confusion',
                competitor2: 'A temporary fix'
              }].map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-1913">
                    <td className="py-6 px-6 font-bold text-[#111111]" data-id="element-1914">
                      {row.label}
                    </td>
                    <td className="py-6 px-6 font-medium text-[#631bb7] bg-[#631bb7] bg-opacity-5" data-id="element-1915">
                      {row.caveo}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-1916">
                      {row.competitor1}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-1917">
                      {row.competitor2}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-1918">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-1919">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-12 text-center" data-id="element-1920">
            Your Questions, Answered.
          </h2>
          <div className="space-y-6" data-id="element-1921">
            {[{
            q: 'Can I cancel my subscription at any time?',
            a: 'Yes. You can cancel your monthly or annual plan at any time from your account settings. No questions asked. Your plan will remain active until the end of the current billing period.'
          }, {
            q: 'What happens when you add new modules or features?',
            a: "All new modules and feature updates are included in the Individual, Family, and Lifetime plans at no extra cost. Our platform is constantly evolving to meet new threats, and you'll always have the latest protection."
          }, {
            q: 'How does the Family Plan work for different family members?',
            a: "The Family Plan gives you a central dashboard to invite up to 5 other family members. You can use our role-based views to see different information; for example, an adult child can see their parent's progress and help them with tasks, while the parent sees a simplified view focused on their own learning."
          }, {
            q: 'Is the Free (Foundation) plan free forever?',
            a: "Yes. The Foundation plan is free forever. It's a great way to get started with our basic security assessment and introductory modules to see how Caveo works."
          }, {
            q: 'What if I’m not satisfied?',
            a: "We offer a 30-day money-back guarantee on all paid plans, including lifetime memberships. If you're not happy for any reason, just let us know within 30 days of your purchase for a full refund."
          }].map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-1922">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-1923">
                  {faq.q}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1924">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1925">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-1926">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-1927">
            Ready to build your family's digital confidence?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-1928">
            Take the first step toward a safer, simpler digital life. Start with
            a free assessment or choose a plan to unlock the full power of Caveo
            today.
          </p>
          <Link to="/intro-assessment" className="inline-block bg-#[631bb7] text-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-#[521099] transition-all shadow-lg transform hover:-translate-y-1" data-id="element-1929">
            Get Started for Free
          </Link>
        </div>
      </section>

      <Footer data-id="element-1930" />
    </div>;
}